import type { SystemMessage } from '@/components/header/types'
import { get } from '@/util/auth'

import { API_ROUTE_SYSTEM_MESSAGES } from './apiRoutes'

const systemMessagesResources = {
  getList: (): Promise<SystemMessage[]> => get(API_ROUTE_SYSTEM_MESSAGES),
}

export default systemMessagesResources
